import React, { useCallback, useEffect, useRef, useState } from "react";
import rightarrow from "../../../assets/img/icons/right-arrow-blur.svg";
import leftarrow from "../../../assets/img/icons/left-arrow.svg";
import gallery from "../../../assets/img/icons/gallery-add.svg";
import cancel from "../../../assets/img/icons/close-square.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { SampleNextArrow, SamplePrevArrow } from "../../shared/Arrow";
import ImageGallery from 'react-image-gallery';

import "swiper/css/navigation";
// Import Swiper styles
import "swiper/css";
const PlaceSlider = ({inforesidencedetail}) => {
  const sliderRef = useRef(null);
  const [gallerySlide, setgallerySlide] = useState(false)
  const [images, setimages] = useState([])
  useEffect(() => {
    //inforesidencedetail.images[1].path
    let img = []
    for (  let x of inforesidencedetail.images ){
     img.push({
      original: x.path,
      thumbnail: x.path,
    },)
    }
    setimages(img)
  }, [])
  

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  return (
    <div className="PlaceSlider mt-[40px]">
      <div className="PlaceSlider--slider relative">
        <div className="PlaceSlider--navigation">
          <img
            src={rightarrow}
            className="PlaceSlider--next"
            onClick={handlePrev}
            alt='next'
          />
          <img
            src={leftarrow}
            className="PlaceSlider--prev"
            onClick={handleNext}
            alt='prev'

          />
        </div>
        <Swiper slidesPerView={1} ref={sliderRef} loop>
          {inforesidencedetail.images.map(i=><SwiperSlide>
            <img src={i.path} />
          </SwiperSlide>)
         }
          ...
        </Swiper>
        
      </div>
    
      <div className="mr-[26px] PlaceSlider--img ">
      <img src={inforesidencedetail.images[0].path} className="mb-[26px] h-[198.02px] w-full PlaceSlider--img--image"/>
        <div className="relative PlaceSlider--img--images" onClick={()=>setgallerySlide(true)}>
          <img src={inforesidencedetail.images[1].path}  className=" h-[198.02px] w-full PlaceSlider--img--image"/>
          <div className=" absolute top-[33%] left-[33%] flex flex-col  justify-center items-center ">
            <img src={gallery}  />
            <p className="text-[#fff] text-[18px] mt-[11px]">
            مشاهده تصاویر
            </p>

          </div>
        </div>

      </div>
        
     {gallerySlide && <div className="galley-back" >
       <button onClick={()=>setgallerySlide(false)}className="galley-back-close">
         <img src={cancel}/>
       </button>
     <div onClick={(e)=>e.stopPropagation()}>
     <ImageGallery  showFullscreenButton={false} thumbnailHeight={600} infinite={true} showPlayButton={false} fullscreen items={images} /></div>
     </div>}
    </div>
  );
};

export default PlaceSlider;
